import { CAMPAIGNS_API_URL } from 'constants/ApiConstants';
import * as types from 'modules/campaignFiles/actionTypes';
import { cleanPayload } from 'utils/RequestUtils';

/**
 * @param {Object} [meta={}]
 * @returns {import("modules/global/generic.types").Action<undefined>}
 */
export const openCreationModal = (meta = {}) => ({
  type: types.OPEN_CREATION_MODAL,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import("modules/global/generic.types").Action}
 */
export const closeCreationModal = (meta = {}) => ({
  type: types.CLOSE_CREATION_MODAL,
  meta,
});

/**
 * @param {string} campaignId
 * @param {import("../types").CreateBulkPayload} data
 * @param {Object} [meta={}]
 * @returns {import("../types").CreateBulkFilesAction}
 */
export const createBulkFiles = (campaignId, data, meta = {}) => {
  const dataRequestFormatted = Object.entries(data).reduce((acc, [key, value]) => {
    if (Array.isArray(value) && value.length === 0) {
      return acc;
    }
    return { ...acc, [key]: value };
  }, {});

  return {
    type: types.CREATE_BULK_FILES,
    payload: {
      campaignId,
      request: {
        method: 'POST',
        url: `${CAMPAIGNS_API_URL}/${campaignId}/campaignFiles/bulk`,
        data: cleanPayload(dataRequestFormatted),
      },
    },
    meta,
  };
};

/**
 * @param {string} campaignId
 * @param {Object} [meta = {}]
 * @returns {import("../types").CreateBulkFilesSuccessAction}
 */
export const createBulkFileSuccess = (campaignId, meta) => ({
  type: types.CREATE_BULK_FILES_SUCCESS,
  payload: { campaignId },
  meta,
});

/**
 * @param {{ campaignId: string, campaignFileId: string } & import("../types").CreateFileActionPayload} data
 * @param {Object} [meta = {}]
 * @returns {import("../types").CreateFileAction}
 */
export const createFile = ({ campaignId, campaignFileId, ...data }, meta = {}) => ({
  type: types.CREATE_FILE,
  payload: {
    campaignId,
    request: {
      method: 'POST',
      url: `${CAMPAIGNS_API_URL}/${campaignId}/campaignFiles/${campaignFileId}/intervention`,
      data,
    },
  },
  meta,
});

/**
 * @param {string} field
 * @param {unknown} value
 * @param {Object} [meta={}]
 * @returns {import("../types").SetCampaignFilesBulkFilterAction}
 */
export const setCampaignFilesBulkFilter = (field, value, meta = {}) => ({
  type: types.SET_CAMPAIGN_FILES_BULK_FILTER,
  payload: { field, value },
  meta,
});

/**
 * @param {string} field
 * @param {unknown} value
 * @param {Object} [meta={}]
 * @returns {import("../types").RemoveCampaignFilesBulkFiltersAction}
 */
export const removeCampaignFileBulkFilter = (field, value, meta = {}) => ({
  type: types.REMOVE_CAMPAIGN_FILES_BULK_FILTER,
  payload: { field, value },
  meta,
});

/**
 * @param {unknown} payload
 * @param {Object} [meta={}]
 * @returns {import("../types").ClearCampaignFilesBulkFiltersAction}
 */
export const clearCampaignFilesBulkFilters = (payload, meta = {}) => ({
  type: types.CLEAR_CAMPAIGN_FILES_BULK_FILTER,
  payload,
  meta,
});

/**
 * @param {import("../reducers/ui/filters").CampaignFileUIDetailsFiltersReducer} payload
 * @param {Object} [meta={}]
 * @returns {import("../types").ImportCampaignFilesBulkFiltersAction}
 */
export const importCampaignFilesBulkFilters = (payload, meta = {}) => ({
  type: types.IMPORT_CAMPAIGN_FILES_BULK_FILTER,
  payload,
  meta,
});
